
// import wikiTextScroll from '~/components/common/wikiTextScroll.vue'
import commonImg from '~/components/common/commonImg.vue'
import Scorenum from '~/components/common/Scorenum.vue'
import Label from '~/components/common/Label.vue'
export default {
  components: {
    // 'wiki-text-scroll': wikiTextScroll,
    'common-img': commonImg,
    Scorenum,
    Label
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    isAdv: {
      // 是否广告
      type: Boolean,
      default: true
    },
    index: {
      // 索引
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: ''
    },
    lzshow: {
      // 图片是否懒加载
      type: Boolean,
      default: true
    },
    ismore: {
      // label是否有加载更多
      type: Boolean,
      default: true
    },
    num: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      value: 0,
      traderIndex: -1,
      selectshow: false,
      labelmore: false
    }
  },
  computed: {
    // 星星的算法
    windsorStar() {
      if (!this.item.score) return
      return parseInt(this.item.score)
    }
  },
  mounted() {
    console.log("关联品牌", this.item)
    // this.setele()
    console.log(this.item, 4442, this.item.specialtyLabels)
  },
  methods: {
    setele() {
      // 计算labei下拉
      const ele = document.getElementById('r-bom-more')
      if (ele && ele.clientHeight > 22) this.selectshow = true
    }
  }
}
